"use client";
import { createContext, useContext, useState } from "react";

const FilterContext = createContext(undefined);

export const useFilterContext = () => {
	const context = useContext(FilterContext);
	if (!context) {
		throw new Error("useFilterContext must be used within a FilterProvider");
	}
	return context;
};

export const FilterProvider = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<FilterContext.Provider
			value={{
				isOpen,
				setIsOpen,
			}}
		>
			{children}
		</FilterContext.Provider>
	);
};
